export const getFinals = state => state.finals.list;
